// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  BACKDROP: '[data-fragment="Sidebar.backdrop"]',
  CLOSE: '[data-fragment="Sidebar.close"]',
  TRIGGER: '[data-fragment="Sidebar.trigger"]',
};

export default class Sidebar extends WebComponent {
  constructor (props) {
    super(props);

    this.state = {
      opened: false,
      scrollPosition: 0,
    };

    this.initTrigger = this.initTrigger.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
  }

  didMount() {
    this.on('click', fragments.CLOSE, this.close);
    this.on('click', fragments.BACKDROP, this.close);
    document.addEventListener('touchstart', this.handleTouchStart, false);
    document.addEventListener('touchmove', this.handleTouchMove, false);
    this.triggers = [...document.body.querySelectorAll(fragments.TRIGGER)];
    this.triggers.map(this.initTrigger);
    this.xDown = null;
    this.yDown = null;

    $(document).on('afterContentsReplaced', () => {
      this.triggers = [...document.body.querySelectorAll(fragments.TRIGGER)];
      this.triggers.map(this.initTrigger);
    });

    /* get param sidebarOpen from url rezervace-restaurace*/
    setTimeout(() => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const paramSidebarOpen = urlParams.get('sidebarOpen')
      const paramSidebarValue = document.querySelector('#'+paramSidebarOpen);
      if(paramSidebarValue && this.element.id === paramSidebarOpen) {
        this.setState({
          opened: true,
        });
      }
    }, 0);
  }

  initTrigger = (el) => {
    if (el.dataset.target === this.element.getAttribute('id')) {
      el.addEventListener('click', this.open);
    }
  };

  open = (e) => {
    e.preventDefault();
    if(e.target.dataset.dynamic) {
       let iframe = this.element.querySelector('iframe');
       let iframeSrcLastIndex = iframe.dataset.src.lastIndexOf("/");
       let iframeSrc = iframe.dataset.src.slice(0, iframeSrcLastIndex + 1) + e.target.dataset.dynamicId + iframe.dataset.src.slice(iframeSrcLastIndex + 1, iframe.dataset.src.length);
       iframe.setAttribute('src', iframeSrc);
    }
    const headline = e.target.innerText;
    window.dataLayer.push({
      'event': 'form_view',
      'form_view': {
        'url': window.location.href,
        'name': headline,
        'target': e.target.dataset.target,
      },
      _clear: true
    });
    this.setState({
      opened: true,
    });
    if (/Android/.test(navigator.appVersion)) {
      this.setState({
        scrollPosition: document.documentElement.scrollTop,
      });
      setTimeout(() => {
        document.documentElement.scrollTop = 0;
      }, 350);
    }
  };

  close = () => {
    this.setState({
      opened: false,
    });
    if (/Android/.test(navigator.appVersion)) {
      document.documentElement.scrollTop = this.state.scrollPosition;
    }
    const headline = this.element.querySelector('.sidebar__headline');
    if(headline) {
      window.dataLayer.push({
        'event': 'form_close',
        'form_view': {
          'url': window.location.href,
          'name': headline.textContent,
        },
        _clear: true
      });
    }

  };

  handleTouchStart = (e) => {
    const firstTouch = e.touches[0];
    this.xDown = firstTouch.clientX;
    this.yDown = firstTouch.clientY;
  };

  handleTouchMove = (e) => {
    if (!this.xDown || !this.yDown) {
      return;
    }
    const xUp = e.touches[0].clientX;
    const yUp = e.touches[0].clientY;
    const xDiff = this.xDown - xUp;
    const yDiff = this.yDown - yUp;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff < 0) {
        this.close();
      }
    }
    this.xDown = null;
  };

  willUnMount() {}

  update() {
    const { opened } = this.state;
    classNames(this.element, { 'sidebar--opened': opened });
    classNames(document.body, { 'overflow-full--iframe': opened });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Sidebar.js